import React, { Component } from 'react';
import axios from 'axios';
import axiosRetry from 'axios-retry';
import { Table } from 'semantic-ui-react';
import moment from 'moment';
import numeral from 'numeral';

import Error from '../../components/error';
import Loading from '../../components/loading';


const _ = require('lodash');

const rowStyle = { cursor: 'pointer' };

class ProfileList extends Component {
  constructor() {
    super();
    this.state = {};
    this.client = axios.create({
      // baseURL: process.env.REACT_APP_API_URL,
      baseURL: 'https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production/profiles',
      timeout: 10000,
    });

    axiosRetry(this.client, {
      retries: 3,
      delay: 100,
      retryCondition: error => !error.response || (error.response.status >= 500 && error.response.status <= 599),
    });
  }

  componentDidMount = () => {
    // create a form with name and email

    this.client.get()
      .then(r => {
        const { meta, data } = r.data;
        this.setState({
          loading: false,
          meta,
          profileList: data,
        });
      })
      .catch(error => {
        window.onerror(error);
        this.setState({
          error,
        });
      });
  }


  render = () => {
    const { profileList, error } = this.state;


    if (profileList) {
      return (
        <Table selectable style={rowStyle}>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Name</Table.HeaderCell>
              <Table.HeaderCell>Instagram</Table.HeaderCell>
              <Table.HeaderCell>Followers</Table.HeaderCell>
              <Table.HeaderCell>Status</Table.HeaderCell>
              <Table.HeaderCell>Created</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {
              _.map(profileList, p => (
                <Table.Row onClick={() => window.open(`/profile/${p.dyzioId}`, '_blank')}>
                  <Table.Cell>
                    {p.name}
                  </Table.Cell>
                  <Table.Cell>
                    {p.instagram}
                  </Table.Cell>

                  <Table.Cell>
                    {numeral(p.instagramFollowers).format('0,0')}
                  </Table.Cell>
                  <Table.Cell>
                    PROCESSED
                  </Table.Cell>
                  <Table.Cell>
                    {moment(p.createdDate).format('LLL')}
                  </Table.Cell>
                </Table.Row>
              ))
            }
          </Table.Body>
        </Table>
      );
    }

    if (error) {
      return (
        <Error error={error} />
      );
    }

    return (
      <Loading resource="profile" />
    );
  }
}

export default ProfileList;



// WEBPACK FOOTER //
// ./src/containers/profile-list/index.js